
import { Event } from "@/lib/types";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface EventTicketCTAProps {
  event: Event;
}

export const EventTicketCTA = ({ event }: EventTicketCTAProps) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white border-b border-gray-200 p-6">
      <div className="relative group">
        {event.quantityStanding < 20 && (
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 flex items-center gap-2 text-red-500 font-medium animate-pulse">
            <span className="text-lg">🔥</span> Selling Fast!
          </div>
        )}
        <Button
          onClick={() => navigate(`/events/${event.seoUrl}/ticketing`)}
          className="
            w-full relative overflow-hidden
            bg-gradient-to-r from-purple-600 via-pink-500 to-purple-600
            bg-[length:200%_100%]
            text-xl py-6 text-white font-bold tracking-wide
            rounded-lg shadow-lg
            transition-all duration-300 ease-out
            hover:shadow-xl hover:scale-[1.02]
            active:scale-[0.98] active:shadow-inner
            disabled:opacity-70 disabled:cursor-not-allowed
            before:absolute before:inset-0
            before:bg-white/10 before:rounded-lg
            before:translate-x-[-100%] hover:before:translate-x-[100%]
            before:transition-transform before:duration-500
            focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2
            min-h-[48px] aria-label='Purchase tickets for this event'
            group-hover:bg-pos-100 backdrop-filter backdrop-blur-sm
          "
          aria-label="Purchase tickets for this event"
        >
          <span className="relative z-10 flex items-center justify-center gap-2">
            <span className="text-2xl">🎟️</span>
            Get Tickets
            <span className="ml-2 text-sm font-normal opacity-80">
              From ${event.priceGeneralAdmission}
            </span>
          </span>
        </Button>
      </div>
    </div>
  );
};
